import React from 'react';
import { Link } from 'react-router-dom';
import './MainMenu.css'; // Import the CSS file for styling

const MainMenu = () => {
  return (
    <nav className="main-menu">
      <div className="logo">
        <Link to="/">
          <img src="/logo.png" alt="US Gas Price Logo" />
        </Link>
      </div>
      <input type="checkbox" id="menu-toggle" className="menu-toggle" />
      <label htmlFor="menu-toggle" className="menu-icon">
        <span></span>
        <span></span>
        <span></span>
      </label>
      <ul className="menu">
        <li><Link to="/">Gas Prices</Link></li>
        <li><Link to="/cost-calculator">Cost Calculator</Link></li>
        <li><Link to="/carbon-calculator">CO2 Calculator</Link></li>
        <li><Link to="/history">History</Link></li>
      {/*  <li><Link to="/news">News</Link></li> */}
      </ul>
    </nav>
  );
};

export default MainMenu;